import { InvoiceStatus } from '../models/invoice';
import { ProposalStatus } from '../models/proposal';
import { WorkOrderStatus } from '../models/workOrder';
import { BillStatus } from '../models/bill';

// EPIC_VOID_FLOW_2026-10 (item 1570, Chad: "require a void before an invoice is archived … same
// flow for all"). Mirrors basix.bl/Generic/ArchiveRules.cs: void is the only way to kill a
// document; Archive only tidies away ones that are already done. The server enforces it too.
interface Row { isVoid?: boolean; status?: number | null }

export const VOID_FIRST = 'Void it first — archive only tidies away documents that are already done.';

export const canArchiveInvoice = (r: Row): boolean => !!r.isVoid
  || r.status === InvoiceStatus.Paid || r.status === InvoiceStatus.PaidEntered || r.status === InvoiceStatus.WrittenOff;

export const canArchiveProposal = (r: Row): boolean => !!r.isVoid
  || r.status === ProposalStatus.Declined || r.status === ProposalStatus.Complete;

export const canArchiveWorkOrder = (r: Row): boolean => !!r.isVoid || r.status === WorkOrderStatus.InvoicesGenerated;

// backend PurchaseOrderStatus: Draft 1, New 2, NewEntered 3, Paid 4, PaidEntered 5 — the web enum
// in models/purchaseOrder.ts is shifted, so compare the server's numbers directly
export const canArchivePurchaseOrder = (r: Row): boolean => !!r.isVoid || r.status === 4 || r.status === 5;

// Entered = in QuickBooks but still unpaid (item 555), so only Paid counts
export const canArchiveBill = (r: Row): boolean => !!r.isVoid || r.status === BillStatus.Paid;
